import { To } from 'react-router-dom';
import { Card } from '@antimatterhq/ui/components/card';
import { Link, Text } from '@antimatterhq/ui/components/typography';

interface BaseHomepageSummaryCardProps {
  title: string;
  to?: To;
  children?: React.ReactNode;
}

export const BaseHomepageSummaryCard = ({
  title,
  to,
  children,
}: BaseHomepageSummaryCardProps) => {
  return (
    <Card className="flex-grow-0 bg-white p-4 dark:bg-grey-800">
      <div className="flex items-center justify-between">
        <Text size="lg" className="font-bold">
          {title}
        </Text>
        {to ? (
          <Link size="sm" to={to}>
            View All
          </Link>
        ) : null}
      </div>
      {children}
    </Card>
  );
};
